import OperatorLabel from "./OperatorLabel";

import { cn } from "@/lib/utils";

interface OperatorPillProps {
  operator?: string;
  field?: string;
  nestedKey?: string;
  onClick?: () => void;
}

const baseClassName =
  "inline-flex h-7 shrink-0 items-center rounded-md border border-slate-200 bg-white px-2.5 text-sm font-medium text-slate-600 shadow-sm shadow-slate-200/70";

const OperatorPill = ({ operator, field, nestedKey, onClick }: OperatorPillProps) => {
  const label = <OperatorLabel operator={operator} field={field} nestedKey={nestedKey} />;

  if (!onClick) {
    return <span className={baseClassName}>{label}</span>;
  }

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        baseClassName,
        "transition-colors hover:border-slate-300 hover:bg-slate-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-200",
      )}
    >
      {label}
    </button>
  );
};

export default OperatorPill;
